import {zodResolver} from '@hookform/resolvers/zod'
import {z} from 'zod'

export const DELIVERY_ANNOTATION_MAX_CHARS = 500

const deliveryAnnotationContentSchema = z.object({
  content: z
    .string()
    .trim()
    .min(1, 'Delivery annotation content is required')
    .max(DELIVERY_ANNOTATION_MAX_CHARS, `Delivery annotation must be ${DELIVERY_ANNOTATION_MAX_CHARS} characters or less`)
})

export type DeliveryAnnotationFormSchema = z.infer<typeof deliveryAnnotationContentSchema>

export const buildDeliveryAnnotationResolver = () => {
  return zodResolver(deliveryAnnotationContentSchema)
}
